export const staticPath = (postfix: string) =>
  process.env.NEXT_PUBLIC_S3_STATIC + postfix;
